export default __webpack_public_path__ + "b7fe6572abcbb82b5137e1f60c315f2c.png";